import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AdminNavbar from "../Components/AdminNavbar";

export default function Newsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/get-subscription.php");
      if (res.data.status === "success") {
        setSubscribers(res.data.data || []);
      } else {
        Swal.fire("Error", res.data.message || "Failed to fetch subscribers.", "error");
      }
    } catch (err) {
      console.error("Error fetching subscribers", err);
      Swal.fire("Error", "Something went wrong!", "error");
    }
    setLoading(false);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(subscribers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscribers");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "newsletter_subscribers.xlsx");
  };

  const filteredData = subscribers.filter((item) =>
    item.email.toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
  name: "Subscribed At",
  selector: (row) => new Date(row.subscribed_at).toLocaleDateString(),
  sortable: true,
}

  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >
      <AdminNavbar />
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-warning">Newsletter Subscribers</h2>
        <button className="btn btn-success" onClick={exportToExcel}>
          Download Excel
        </button>
      </div>

      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search by email..."
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />

      <DataTable
        columns={columns}
        data={filteredData}
        progressPending={loading}
        pagination
        highlightOnHover
        striped
        theme="dark"
        persistTableHead
        responsive
        noDataComponent="No subscribers found."
      />
    </motion.div>
  );
}
